module.exports = __webpack_public_path__ + "media/bootstrap-icons/minecart-loaded-f3f1ef76.svg";